export const DRAFT_CLOSE_ACTION = {
  discardDraft: 'discardDraft',
  saveDraft: 'saveDraft',
}

export const DRAFT_CREATE_ACTION = {
  createNew: 'createNew',
  openDraft: 'openDraft',
}
